import { waLink, track } from "@/constants/site";
import Reveal from "@/components/base/Reveal";

const BENEFITS = [
  {
    icon: "ri-money-dollar-circle-line",
    title: "Investimento inteligente",
    description: "Alternativa de custo reduzido para manter a operação em funcionamento.",
  },
  {
    icon: "ri-tools-line",
    title: "Processo técnico",
    description: "Recuperação com procedimentos de manutenção eletromecânica.",
  },
  {
    icon: "ri-time-line",
    title: "Disponibilidade",
    description: "Opção para quem precisa de solução com agilidade comercial.",
  },
];

export default function Reconditioned() {
  return (
    <section className="bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-24">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-14">
          <Reveal>
            <p className="text-xs font-bold uppercase tracking-[0.16em] text-accent-600">
              Motores recondicionados
            </p>
            <h2 className="mt-3 font-heading text-3xl font-extrabold tracking-tight text-foreground-950 md:text-4xl">
              Motores recondicionados: desempenho com investimento inteligente
            </h2>
            <p className="mt-4 text-base leading-relaxed text-foreground-600">
              Para quem precisa colocar o equipamento de volta em operação, os motores
              recondicionados representam uma alternativa com melhor relação custo-benefício.
              A aplicação e o modelo devem ser avaliados conforme a sua necessidade.
            </p>

            <div className="mt-8 space-y-4">
              {BENEFITS.map((b) => (
                <div key={b.title} className="flex gap-4">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                    <i className={`${b.icon} text-xl`} aria-hidden="true" />
                  </span>
                  <div>
                    <h4 className="font-bold text-foreground-900">{b.title}</h4>
                    <p className="mt-1 text-sm leading-relaxed text-foreground-600">
                      {b.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <a
              href={waLink("Olá! Gostaria de saber mais sobre motores recondicionados.")}
              target="_blank"
              rel="noreferrer"
              onClick={() => track("product_view", { product: "motores_recondicionados" })}
              className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-base font-bold text-background-50 transition-colors hover:bg-primary-600"
            >
              Consultar disponibilidade
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </a>
          </Reveal>

          <Reveal delay={120}>
            <div className="relative overflow-hidden rounded-lg border border-background-200">
              <img
                src="https://storage.helloreaddy.io/project_files/f9d550f4-c229-4b78-8b12-ba157551dbe2/1bd4792a-55a9-4b7b-94c7-739df3add792_compressed_powermotoreseletricos-3.webp"
                alt="Motor elétrico WEG recondicionado laranja"
                title="Motor recondicionado WEG - Power Motores Elétricos"
                className="h-full w-full object-cover object-center"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}